import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Reports } from "./../actions/apiActions";
import { enqueueSnackbar } from "notistack";

export const reportsDefaultState = {
  AutoZeroReport: {
    entries: [],
  },
  QAL3: {
    entries: [],
  },
  EnergiesReportDay: {
    entries: [],
  },
  EnergiesReportMonth: {
    entries: [],
  },
  SteamTrapReport: {
    entries: [],
  },
};

export const fetchReports = createAsyncThunk(
  "reports/fetchReports",
  async (data, thunk) => {
    const { t, systemId, url, type, args } = data;
    const { config } = thunk.getState().config[systemId].system;
    if (config) {
      const option =
        {
          CustomerId: config.CUSTOMER_ID,
          deviceId: config.DEVICE_ID,
          ...args,
        } || {};
      const response = await Reports.post(`${config.DATA_URL}${url}`, option);
      return { response, systemId, name: type };
    }
  }
);

export const fetchReportsWithTimeRange = createAsyncThunk(
  "reports/fetchReportsWithTimeRange",
  async (params, thunk) => {
    const { systemId, args } = params;
    const { config } = thunk.getState().config[systemId].system;
    if (config) {
      try {
        const data =
          {
            CustomerId: config.CUSTOMER_ID,
            DeviceId: config.DEVICE_ID,
            ...args,
          } || {};
        const response = await Reports.getReportsWithTimeRange(config.DATA_URL, data);
        return { response, systemId, name: args.ReportName };
      } catch (err) {
        enqueueSnackbar("Failed to fetch " + args.ReportName + " reports", { variant: "error" });
      }
    }
  }
);

export const resendReports = createAsyncThunk(
  "reports/resendReports",
  async (params, thunk) => {
    const { systemId, args } = params;
    const { config } = thunk.getState().config[systemId].system;
    if (config) {
      try {
        const data =
          {
            CustomerId: config.CUSTOMER_ID,
            DeviceId: config.DEVICE_ID,
            ...args,
          } || {};
        const response = await Reports.resendReports(config.DATA_URL, data);
        return { response, systemId, name: args.ReportName };
      } catch (err) {
        enqueueSnackbar("Failed to resend " + args.ReportName + " reports", { variant: "error" });
      }
    }
  }
);

const reportsSlice = createSlice({
  name: "reports",
  initialState: reportsDefaultState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resendReports.fulfilled, (state, action) => {
        if (action.payload) {
          enqueueSnackbar("Reports resend requested", { variant: "success" });
        }
      })
      .addCase(resendReports.rejected, (state, action) => {
        enqueueSnackbar("Failed to resend reports", { variant: "error" });
      })
      .addCase(fetchReportsWithTimeRange.fulfilled, (state, action) => {
        if (action.payload.name === "AutoZero") {
          state.AutoZeroReport.entries = action.payload.response;
        } else if (action.payload.name === "QAL3") {
          state.QAL3.entries = action.payload.response;
        } else if (action.payload.name === "MonthHeatMap") {
          // Return if response is empty object
          if (Object.keys(action.payload.response).length === 0) {
            state.EnergiesReportDay.entries = [];
            return;
          }
          state.EnergiesReportMonth.entries = action.payload.response;
        } else if (action.payload.name === "DayHeatMap") {
          // Return if response is empty object
          if (Object.keys(action.payload.response).length === 0) {
            state.EnergiesReportDay.entries = [];
            return;
          }
          state.EnergiesReportDay.entries = action.payload.response;
        } else if (action.payload.name === "SteamTrapReport") {
          state.SteamTrapReport.entries = action.payload.response;
        }
      })
      .addCase(fetchReportsWithTimeRange.rejected, (state, action) => {
        enqueueSnackbar("Failed to fetch reports", { variant: "error" });
      })
      .addCase(fetchReports.fulfilled, (state, action) => {
        console.log("fetchReports fulfilled", action.payload);
        if (action.payload.name === "AutoZero") {
          state.AutoZeroReport.entries = action.payload.response;
        } else if (action.payload.name === "QAL3") {
          state.QAL3.entries = action.payload.response;
        } else if (action.payload.name === "EnergiesReport") {
          // There are 2 types of energies report, month/day -reports. Check the first item's ReportName on response array to verify which type is in question
          if (action.payload.response[0].ReportName === "MonthHeatMap") {
            state.EnergiesReportMonth.entries = action.payload.response;
          } else {
            state.EnergiesReportDay.entries = action.payload.response;
          }
        } else if (action.payload.name === "SteamTrapReport") {
          state.SteamTrapReport.entries = action.payload.response;
        }
      })
      .addCase(fetchReports.rejected, (state, action) => {
        enqueueSnackbar("Loading Report failed", { variant: "warning" });
      });
  },
});

export const { } = reportsSlice.actions;

export default reportsSlice.reducer;
